// src/pages/Login.jsx
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Images from "../assets/Image";

const Login = () => {
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleGetOtp = async (e) => {
    e.preventDefault();
    setError("");

    const cleaned = mobile.replace(/\D/g, "");
    if (cleaned.length !== 10) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    // Generate OTP (6 digits)
    const otp = Math.floor(100000 + Math.random() * 900000);

    try {
      setLoading(true);

      // <-- DIRECT CALL (POST with query params, empty body) -->
      const response = await axios.post(
        "https://capi.2kvirtualworld.com/usppackinglive/api/sms/send-otp",
        {}, // empty body is important: API expects query params not JSON payload
        {
          params: {
            phoneNumber: cleaned,
            otp: otp,
          },
          // you can set timeout if needed:
          timeout: 15000,
        }
      );

      console.log("OTP API Response:", response.data);

      // Save OTP and mobile — used on verify page
      sessionStorage.setItem("login_otp", String(otp));
      sessionStorage.setItem("login_mobile", cleaned);

      navigate("/verifyotp");
    } catch (err) {
      console.error("Error sending OTP:", err);

      // If server responded with data, show it, else generic message
      const msg =
        err?.response?.data ||
        err?.message ||
        "Failed to send OTP. Please try again.";
      setError(String(msg));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="left-card">
        <div className="image-box">
          <img
            src={Images?.usplogin}
            className="welcome-image img-fluid"
            alt="welcome"
          />
        </div>
      </div>

      <div className="login-card">
        {/* <h5 className="login-title">USP Packaging Solutions</h5> */}
        <img src={Images?.uspLogo} alt="USP Logo" className="login-page-logo" />

        <form className="login-form" onSubmit={handleGetOtp}>
          <label className="login-label">Enter Your Mobile Number</label>

          <div className="input-group">
            <span className="prefix">+91</span>
            <input
              type="tel"
              inputMode="numeric"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              maxLength={10}
              className="login-input"
              placeholder="Enter mobile number"
              required
            />
          </div>

          {error && <p className="error-msg">{error}</p>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Sending..." : "Get OTP"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
